<template>
  <v-col >
    <v-card class="align-start metrics-card-top monthly-performance">
      <v-card-title class="d-flex justify-space-between">
        <div class="hidden-element">Hidden</div>
        <!--Hidden element to allow center and right align of label and icon-->
        <label class="font-weight-bold text-decoration-underline">Monthly Performance</label>
        <tooltip>
          <p>Average performance, per month, compared with the average performance against the last 3 months</p>
        </tooltip>
      </v-card-title>
      <v-card-text class="d-flex justify-center align-center">
        <div class="d-flex flex-column align-start pr-3">
          <label class="mb-3">Last 30 days</label>
          <current-month-performance-stats :loading="loading" label="Chats Opened">
            {{ chatsOpened }}
          </current-month-performance-stats>
          <current-month-performance-stats :loading="loading" label="Chats Engaged">
            {{ engagements }} <span v-if="engagements !== 0">({{countPercentage(engagements, chatsOpened)}}%)</span>
          </current-month-performance-stats>
          <current-month-performance-stats :loading="loading" label="Agent Requests">
            {{ agentsRequested }} <span v-if="agentsRequested !== 0">({{countPercentage(agentsRequested, engagements)}}%)</span>
          </current-month-performance-stats>
          <current-month-performance-stats :loading="loading" label="Chats Joined">
            {{ chatsJoined }} <span v-if="chatsJoined !== 0">({{countPercentage(chatsJoined, agentsRequested)}}%)</span>
          </current-month-performance-stats>
        </div>
        <v-divider class="mb-1" vertical />
        <div class="d-flex flex-column align-start pl-2">
          <label class="mb-3">Past 90 days monthly average</label>
          <div class="d-flex align-center mb-2">
            <label v-if="!loading" class="text--primary text-h6 font-weight-bold">
              {{ chatsOpenedAverage | formatNumber }}
              <values-percentage-diff :value="chatsOpened" :prev-value="chatsOpenedAverage" />
            </label>
            <v-skeleton-loader v-if="loading" type="table-cell"/>
          </div>
          <div class="d-flex align-center mb-2">
            <label v-if="!loading" class="text--primary text-h6 font-weight-bold">
              {{ engagementsAverage | formatNumber }}
              <values-percentage-diff :value="engagements" :prev-value="engagementsAverage" />
            </label>
            <v-skeleton-loader v-if="loading" type="table-cell"/>
          </div>
          <div class="d-flex align-center mb-2">
            <label v-if="!loading" class="text--primary text-h6 font-weight-bold">
              {{ agentsRequestedAverage | formatNumber }}
              <values-percentage-diff :value="agentsRequested" :prev-value="agentsRequestedAverage" />
            </label>
            <v-skeleton-loader v-if="loading" type="table-cell"/>
          </div>
          <div class="d-flex align-center mb-2">
            <label v-if="!loading" class="text--primary text-h6 font-weight-bold">
              {{ chatsJoinedAverage | formatNumber }}
              <values-percentage-diff :value="chatsJoined" :prev-value="chatsJoinedAverage" />
            </label>
            <v-skeleton-loader v-if="loading" type="table-cell"/>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import Tooltip from "@/components/HealthScore/Tooltip.vue";
import {mapState} from "vuex";
import {LoadingState} from "@/store/constants";
import {findEventsCount} from "@/components/HealthScore/healthScoreHelpers";
import ValuesPercentageDiff from "@/components/HealthScore/ValuesPercentageDiff.vue";
import CurrentMonthPerformanceStats from "@/components/HealthScore/CurrentMonthPerformanceStats.vue";

export default {
  name: 'MonthlyPerformance',
  components: {CurrentMonthPerformanceStats, ValuesPercentageDiff, Tooltip},
  computed: {
    ...mapState('healthScoreStore', ['monthlyPerformance']),
    loading() {
      return this.monthlyPerformance.state === LoadingState.LOADING;
    },
    currentMonth() {
      return this.monthlyPerformance.data.currentMonth;
    },
    pastThreeMonths() {
      return this.monthlyPerformance.data.pastThreeMonths;
    },
    chatsOpened() {
      return findEventsCount(this.currentMonth, 'chat_opened');
    },
    engagements() {
      return findEventsCount(this.currentMonth, 'chat_engaged');
    },
    agentsRequested() {
      return findEventsCount(this.currentMonth, 'human_requested');
    },
    chatsJoined() {
      return findEventsCount(this.currentMonth, 'human_answered');
    },
    chatsOpenedAverage() {
      return findEventsCount(this.pastThreeMonths, 'chat_opened') / 3;
    },
    engagementsAverage() {
      return findEventsCount(this.pastThreeMonths, 'chat_engaged') / 3;
    },
    agentsRequestedAverage() {
      return findEventsCount(this.pastThreeMonths, 'human_requested') / 3;
    },
    chatsJoinedAverage() {
      return findEventsCount(this.pastThreeMonths, 'human_answered') / 3;
    },
  },
  filters: {
    formatNumber(value) {
      return Number(parseFloat(value).toFixed(2));
    }
  },
  methods: {
    countPercentage(value, divider) {
      if (divider !== 0) {
        return parseFloat((value / divider * 100).toFixed(2));
      } else {
        return 0;
      }
    }
  },
}
</script>

<style scoped>
.monthly-performance {
  white-space: nowrap;
}
</style>
